export default __webpack_public_path__ + "static/media/gallery.4e2b5591.png";